"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreatedProcessId {
    static getAttributeTypeMap() {
        return CreatedProcessId.attributeTypeMap;
    }
}
CreatedProcessId.discriminator = undefined;
CreatedProcessId.attributeTypeMap = [
    {
        "name": "processId",
        "baseName": "processId",
        "type": "number"
    }
];
exports.CreatedProcessId = CreatedProcessId;
//# sourceMappingURL=createdProcessId.js.map